/**
 * @generated SignedSource<<a03d28b0fa6edcadfba33afc2112cd9e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteGroupInput = {
  clientMutationId?: string | null | undefined;
  id: string;
};
export type DeleteGroupMutation$variables = {
  input: DeleteGroupInput;
};
export type DeleteGroupMutation$data = {
  readonly deleteGroup: {
    readonly clientMutationId: string | null | undefined;
    readonly removedGroupId: string;
  } | null | undefined;
};
export type DeleteGroupMutation = {
  response: DeleteGroupMutation$data;
  variables: DeleteGroupMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteGroupPayload",
    "kind": "LinkedField",
    "name": "deleteGroup",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "removedGroupId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteGroupMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteGroupMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7381e945c94fd7c9bb8e94c75a346216",
    "id": null,
    "metadata": {},
    "name": "DeleteGroupMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteGroupMutation(\n  $input: DeleteGroupInput!\n) {\n  deleteGroup(input: $input) {\n    clientMutationId\n    removedGroupId\n  }\n}\n"
  }
};
})();

(node as any).hash = "5e020240820ab36b933186611b952a24";

export default node;
